import { APIResponse, OrganisationAPIPathGenerator, OrganisationDocument, OrganisationMemberDocument, UserDocument } from "server-model";
import { OrganisationConnector } from "../data-connectors";
import { AppServerConnector } from "./app-server.connector";

export class AppServerOrganisationConnector extends AppServerConnector implements OrganisationConnector {
    async getOrganisation(organisationId: string): Promise<APIResponse> {
        try {
            const response = await this.axios.get(
                OrganisationAPIPathGenerator.details(organisationId),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Organisation not found")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async listOrganisationUsers(organisationId: string): Promise<APIResponse> {
        try {
            const response = await this.axios.get(
                OrganisationAPIPathGenerator.listUsers(organisationId),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Organisation not found")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async createOrganisation(organisationDocument: OrganisationDocument): Promise<APIResponse> {
        try {
            const response = await this.axios.post(
                OrganisationAPIPathGenerator.create(),
                { organisationDocument: this.toPlain(organisationDocument) },
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to create organisation")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async updateOrganisation(organisationId: string, organisationDocument: OrganisationDocument): Promise<APIResponse> {
        try {
            const response = await this.axios.put(
                OrganisationAPIPathGenerator.update(organisationId),
                { organisationDocument: this.toPlain(organisationDocument) },
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to update organisation")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async deleteOrganisation(organisationId: string): Promise<APIResponse> {
        try {
            const response = await this.axios.delete(
                OrganisationAPIPathGenerator.delete(organisationId),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to delete organisation")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
}